import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "./slice/authSlice";
import investarSearchReducer from "./slice/investarSearchSlice";
import propertyDetailsSlice from "./slice/propertyDetailsSlice";
import watchListSlice from "./slice/watchlistSlice";
import analysisSummarySlice from "./slice/analyserSlice";
import myTrackerSlice from "./slice/myTrackerSlice";
import attachmentSlice from "./slice/attachmentsSlice";
import propertyImageSlice from "./slice/propertyImagesSlice";
import searchStateReducer from "./slice/searchStateSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  investar: investarSearchReducer,
  propertyDetails: propertyDetailsSlice,
  watchList: watchListSlice,
  analyser: analysisSummarySlice,
  myTracker: myTrackerSlice,
  attachments: attachmentSlice,
  propertyImages: propertyImageSlice,
  searchState: searchStateReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export type AppDispatch = typeof store.dispatch;

export default store;
